import { useState, useEffect } from 'react';
import { Modal, Form, Input, Radio, Upload, Button, message, Tooltip } from 'antd';
import { InboxOutlined } from '@ant-design/icons';
import { subirManifestacionInteres } from '../../services/manifestacionInteres/manifestacionInteresServices';
const { Dragger } = Upload;

const ModalSubirSoporte = ({ visible, onCancel, oidProyecto, rutaDestino, user, onArchivoSubido, modoMultiple = false }) => {
  const [form] = Form.useForm();
  const [fileList, setFileList] = useState([]);
  const [submitting, setSubmitting] = useState(false);
  const handleCustomRequest = ({ file, onSuccess }) => {
    setTimeout(() => {
      onSuccess("ok");
    }, 0);
  };

useEffect(() => {
    if (!visible) {
      form.resetFields();
      setFileList([]);
    }
  }, [visible, form]);


  const tipoSoporte = (tipo_soporte) => {
    switch (tipo_soporte) {
      case '1':
      case 1:
      case 'Manifestación de Interés':
        return 'Manifestación de Interés';
      default:
        return 'Otro';
    }
  };

  const asegurarExtensionPDF = (nombre) => {
    return nombre.toLowerCase().endsWith('.pdf') ? nombre : `${nombre}.pdf`;
  };


  const handleSubmit = async () => {
    try {
      if (!modoMultiple) {
        await form.validateFields();
      }

      if (fileList.length === 0) {
        message.error('Debe adjuntar al menos un archivo PDF.');
        return;
      }

      const tipo_soporte = tipoSoporte();
      const rutaDestinoFinal = `DocumentosMI/${oidProyecto}/${rutaDestino}`;

      setSubmitting(true);

      for (const file of fileList) {
        const formData = new FormData();
        const titulo = modoMultiple
          ? asegurarExtensionPDF(file.name)
          : asegurarExtensionPDF(form.getFieldValue("titulo"));

        formData.append("oidProyecto", oidProyecto.toString());
        formData.append("rutaDestino", rutaDestinoFinal);
        formData.append("fechaMI", form.getFieldValue("fechaMI") ?? new Date().toISOString());
        formData.append("titulo", titulo);
        formData.append("tipoSoporte", tipo_soporte);
        formData.append("user", user);
        formData.append("archivos", file.originFileObj);

        const response = await subirManifestacionInteres(formData);
        if (response?.data?.length > 0) {
          const nuevoArchivo = response.data[0];
          onArchivoSubido({
            key: nuevoArchivo.oid,
            documento: nuevoArchivo.nameResource,
            usuario: nuevoArchivo.user,
            fecha: nuevoArchivo.fecha_documento,
            fullPath: nuevoArchivo.fullPath,
            detailJSON: nuevoArchivo.detailJSON,
          });
        }
      }

      message.success('Archivos subidos correctamente');
      form.resetFields();
      setFileList([]);
      onCancel();
    } catch (err) {
      if (err?.errorFields) return;
      message.error('Error al subir los archivos');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Modal
      open={visible}
      title="Subir soporte - Manifestación de Interés"
      onCancel={onCancel}
      footer={[
        <Button key="cancelar" onClick={onCancel}>Cancelar</Button>,
        <Button key="guardar" type="primary" loading={submitting} onClick={handleSubmit}>Guardar</Button>,
      ]}
    >
      <Form form={form} layout="vertical">
        {!modoMultiple && (
          <Form.Item
            label="Nombre del soporte"
            name="titulo"
            rules={[
              { required: true, message: 'Por favor, ingrese el Nombre del soporte' },
              {
                pattern: /^[0-9]{8}_MI_C\d+$/,
                message: (
                  <>
                    <p>El formato debe ser: <strong>ddmmyyyy_MI_Cédula del Participante</strong></p>
                    <ul>
                      <li>Fecha en formato día-mes-año (Ej: <code>13022025</code>)</li>
                      <li>Guion bajo</li>
                      <li>Texto <code>MI</code> en mayúsculas</li>
                      <li>Guion bajo</li>
                      <li>Precisar el número de cedula del participante que firmó, precedido por la letra en mayúscula "C".</li>
                    </ul>
                    <p><strong>Ejemplo válido:</strong> <code>13022025_MI_C123456789</code></p>
                  </>
                )
              }
            ]}
          >
            <Input placeholder="Ej: 13022025_MI_C123456789" />
          </Form.Item>
        )}
        {!modoMultiple && (
          <Form.Item
            label="Tipo de soporte"
            name="resourceType"
            rules={[{ required: true, message: 'Por favor, seleccione un tipo de soporte' }]}
          >
            <Radio.Group>
              <Radio value="1">Manifestación de Interés</Radio>
            </Radio.Group>
          </Form.Item>
        )}
        <Form.Item label="Carga de Soporte" required>
          <Tooltip title="Subir Soporte">
            <Dragger
              multiple={modoMultiple}
              customRequest={handleCustomRequest}
              fileList={fileList}
              onChange={({ fileList: newFileList }) => {
                setFileList(modoMultiple ? newFileList : newFileList.slice(-1));
              }}
              beforeUpload={() => false}
              accept=".pdf"
            >
              <p className="ant-upload-drag-icon"><InboxOutlined /></p>
              <p className="ant-upload-text">
                {modoMultiple ? "Puede arrastrar varios archivos PDF" : "Haga clic o arrastre un archivo PDF"}
              </p>
              <p className="ant-upload-hint">Solo se permiten archivos PDF.</p>
            </Dragger>
          </Tooltip>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default ModalSubirSoporte;
